import Styled from '@/components/footers/FormFooter.styled';
import { Container } from '@/components/layout/Container';
import { getBrandColor, hexToRGBA } from '@/styles/color/utils';
import { FC, PropsWithChildren, ReactNode, useMemo } from 'react';

interface FormFooterProps extends PropsWithChildren {
  heading: string;
  text: ReactNode;
  background?: string;
}

const FormFooter: FC<FormFooterProps> = (props) => {
  const color = useMemo(() => {
    if (props.background) {
      const brandColor = getBrandColor(props.background, 'tint');

      if (brandColor) {
        return `linear-gradient(0deg, ${hexToRGBA(brandColor, 1)} 0%, ${hexToRGBA(brandColor, 0)} 100%)`;
      }

      if (props.background.startsWith('gradient')) {
        return `url('/staticwebassets/modules/formfooter/bg-${props.background}.jpg')`;
      }
    }

    return undefined;
  }, [props.background]);

  return (
    <Styled.Footer $background={color} id="form-footer">
      <Container>
        <Styled.Grid>
          <div>
            <Styled.Heading>{props.heading}</Styled.Heading>
            {!!props.text && <Styled.Text>{props.text}</Styled.Text>}
          </div>
          <div>
            <Styled.FormWrapper>{props.children}</Styled.FormWrapper>
          </div>
        </Styled.Grid>
      </Container>
    </Styled.Footer>
  );
};

FormFooter.defaultProps = {
  background: 'transparent',
};

export default FormFooter;
